import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const OrderSuccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const orderDetails = location.state?.orderDetails;

  if (!orderDetails) {
    navigate("/");
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-2xl mx-auto px-4 py-8"
    >
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="bg-green-500 p-6 text-white text-center">
          <svg
            className="w-16 h-16 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <h1 className="text-3xl font-bold mb-2">{t("orderSuccess.title")}</h1>
          <p className="text-lg">{t("orderSuccess.thankYou")}</p>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-4">{t("orderSuccess.orderDetails")}</h2>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <p><span className="font-medium">{t("orderSuccess.orderId")}:</span> #{orderDetails.orderId}</p>
              <p><span className="font-medium">{t("orderSuccess.customerName")}:</span> {orderDetails.customerName}</p>
              <p><span className="font-medium">{t("orderSuccess.phoneNumber")}:</span> {orderDetails.phoneNumber}</p>
              <p><span className="font-medium">{t("orderSuccess.deliveryArea")}:</span> {orderDetails.deliveryArea}</p>
            </div>
            <div className="mt-4">
              <p><span className="font-medium">{t("orderSuccess.address")}:</span> {orderDetails.address}</p>
            </div>
          </div>

          <div className="border-t pt-6">
            <h3 className="text-lg font-semibold mb-4">{t("orderSuccess.orderSummary")}</h3>
            <div className="space-y-4">
              {orderDetails.items.map((item, index) => (
                <div key={index} className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">{item.name}</p>
                    <p className="text-sm text-gray-600">
                      {t("orderSuccess.quantity")}: {item.quantity}
                    </p>
                  </div>
                  <p className="font-medium">EGP{item.price * item.quantity}</p>
                </div>
              ))}
              <div className="border-t pt-4 mt-4">
                <div className="flex justify-between items-center font-semibold">
                  <p>{t("orderSuccess.total")}</p>
                  <p>EGP{orderDetails.totalAmount}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex gap-4">
            <button
              onClick={() => navigate("/")}
              className="flex-1 bg-primeColor text-white py-3 px-6 rounded-lg hover:bg-black transition duration-300"
            >
              {t("orderSuccess.continueShopping")}
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default OrderSuccess;
